import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { EvaluatorTestSetsPage } from "@/features/evaluator-operations/test-sets/evaluator-test-sets-page";
import {
  CALIBRATION_TEST_SET_VALUES,
  EVALUATOR_TEST_SET_SORT_VALUES,
  SORT_DIRECTION_VALUES,
} from "@/features/evaluator-operations/types";

export const Route = createFileRoute("/evaluators/test-sets/")({
  validateSearch: z.object({
    page: z.coerce.number().int().min(1).catch(1),
    limit: z.coerce.number().int().min(1).max(100).catch(10),
    q: z.string().optional(),
    category: z.enum(CALIBRATION_TEST_SET_VALUES).optional(),
    sort: z.enum(EVALUATOR_TEST_SET_SORT_VALUES).catch("updatedAt"),
    direction: z.enum(SORT_DIRECTION_VALUES).catch("desc"),
  }),
  component: () => (
    <PermissionGuard module="evaluators">
      <EvaluatorTestSetsPage />
    </PermissionGuard>
  ),
});
